import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex top-button-group alignC" }
const _hoisted_3 = { class: "flex alignC mar-r-18" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "到期时间", -1)
const _hoisted_5 = { class: "flex alignC" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "提醒类别", -1)
const _hoisted_7 = { class: "flex alignC" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, " 导出 ", -1)
const _hoisted_9 = { style: {"white-space":"pre-wrap"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { style: {"color":"#409EFF"} }
const _hoisted_12 = { style: {"color":"#999","margin-left":"10px"} }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "flex flexC button-group",
  style: {"justify-content":"center"}
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "服务历史", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "已处理", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_18 = { class: "flex flexR mar-t-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.screenParameter.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.date = $event)),
          type: "daterange",
          align: "right",
          "unlink-panels": "",
          "range-separator": "-",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          shortcuts: _ctx.shortcuts,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'start_date')))
        }, null, 8, ["modelValue", "shortcuts"])
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_select, {
          class: "mar-r-16",
          style: {"width":"150px"},
          modelValue: _ctx.screenParameter.status,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.status = $event)),
          placeholder: "请选择",
          clearable: "",
          onChange: _ctx.screenChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "保养到期",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "年检到期",
              value: "2"
            }),
            _createVNode(_component_el_option, {
              label: "商业险到期",
              value: "3"
            }),
            _createVNode(_component_el_option, {
              label: "交强险到期",
              value: "4"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.screenParameter.search,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.search = $event)),
          placeholder: "车牌号码/车架号",
          class: "mar-l-16 mar-r-18",
          "suffix-icon": "el-icon-search",
          onChange: _ctx.screenChange
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.exportChange
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "到期类别",
          align: "center",
          "min-width": "164"
        }, {
          default: _withCtx((scope) => [
            _createVNode("view", _hoisted_9, _toDisplayString(scope.row.text), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "跟进次数",
          align: "center",
          "min-width": "80"
        }, {
          default: _withCtx((scope) => [
            _createVNode("span", null, _toDisplayString(scope.row.deal_num || 0), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "跟进记录",
          align: "center",
          "min-width": "300"
        }, {
          default: _withCtx((scope) => [
            (scope.row.deal_json && scope.row.deal_json.length)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.deal_json, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      style: {"text-align":"left","margin-bottom":"5px"}
                    }, [
                      _createVNode("span", _hoisted_11, _toDisplayString(item.admin_name) + ":", 1),
                      _createVNode("span", null, _toDisplayString(item.remark), 1),
                      _createVNode("span", _hoisted_12, _toDisplayString(item.deal_time), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_13, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "164"
        }, {
          default: _withCtx((scope) => [
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: {
                                path: '/customer/expire/serviceHistory',
                                query: {
                                    car_id: scope.row.car_id,
                                },
                            }
              }, {
                default: _withCtx(() => [
                  (_ctx.roleList.service_history)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "bg-red mar-r-8"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"]),
              (_ctx.roleList.processed)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "border-red mar-r-8",
                    onClick: ($event: any) => (_ctx.handle(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: {
                                path: '/customer/expire/edit',
                                query: {
                                    id: scope.row.car_id,
                                },
                            }
              }, {
                default: _withCtx(() => [
                  (_ctx.roleList.edit)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "border-red"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
}